export const STAGES = {
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    READY_TO_INVOICE: 'READY_TO_INVOICE',
    INVOICED: 'INVOICED',
    APPROVED: 'APPROVED',
    PAID: 'PAID',
};

export const STAGE_DISPLAY_MAPPINGS = {
    [STAGES.PENDING_APPROVAL]: 'Pending Approval',
    [STAGES.READY_TO_INVOICE]: 'Ready to Invoice',
    [STAGES.INVOICED]: 'Invoiced',
    [STAGES.APPROVED]: 'Approved',
    [STAGES.PAID]: 'Paid',
};
